import swal from 'sweetalert2'

function createConfig(options) {
  const config = options
  config.confirmButtonText = options.confirmButtonText || 'Confirmar'
  config.cancelButtonText = options.cancelButtonText || 'Cancelar'
  config.confirmButtonClass = options.confirmButtonClass || 'btn btn-danger'
  config.cancelButtonClass = options.cancelButtonClass || 'btn btn-white'
  config.buttonsStyling = options.buttonsStyling || false
  config.showCancelButton = options.showCancelButton || true
  return config
}

export default options => {
  return swal(createConfig(options))
}
